/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Nomembers2Inputs */

const zh_organizationsettings_nomembers2 = /** @type {(inputs: Organizationsettings_Nomembers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无成员`)
};

const en_organizationsettings_nomembers2 = /** @type {(inputs: Organizationsettings_Nomembers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No members`)
};

const es_organizationsettings_nomembers2 = /** @type {(inputs: Organizationsettings_Nomembers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin miembros`)
};

/**
* | output |
* | --- |
* | "No members" |
*
* @param {Organizationsettings_Nomembers2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_nomembers2 = /** @type {((inputs?: Organizationsettings_Nomembers2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Nomembers2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_nomembers2(inputs)
	if (locale === "en") return en_organizationsettings_nomembers2(inputs)
	return es_organizationsettings_nomembers2(inputs)
});
export { organizationsettings_nomembers2 as "organizationSettings_noMembers" }